
import { GetItemFromStorage, SetItemInStorage } from "../custom_hooks/useStorage";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import _ from "lodash";
import { VideoCallSDK } from "ccaas_videomeet_sdk";
import { config } from "../base/constant";
import publicIp from "public-ip";
import storeRedux from "../store/redux-store/root_store";
import { sharingState } from "../base/models/meetModal";
import { meetActions } from "../store/slices/meet_slice/meetslice";
import { videoCallService } from "../base/service/videoCallService";
import { screenShareReducerAction } from "../store/slices/screenshare_slice/screensharedata";
import { storeCallStatus, storeParticipantVideo, storePrevUserAgent, storeUserAgent, store_Status, throwLoading } from "../base/video_common";
import { actionTypes, meetActionTypes } from "../base/action/action";
import store from "../store/redux-store/root_store";
import { SpeechDetech } from "./speechdetect";
import { toast } from "../annotation";

// 
let {
  EndCall,
  MakeCall,
  Registration,
  startScreenShare
} = VideoCallSDK.Video;

let that: any;
let mixer: any = document.getElementById("audioMixer");
let clearRestart: any;
let isIcefailed = false;
let multiInviteCheck:any=false;
let inviteCheck:any=false;
let isIceTimerStarted: any = false;
// let  videoCallService:any=new VideoCallService();
var audioStream = new MediaStream();
export class meetService {
  public dispatch: any;
  public videoServiceInstance: any
  constructor(dispatch?: any) {
    this.dispatch = dispatch;
    that = this;
  }
  public createCallConnection = async (data: any, medium: string, isguest: boolean, conId: string, userdetails: any) => {
    const meetingDetails: any = store.getState().meetingReducer || {};
    console.log(meetingDetails, "meetingDetails===");

    console.log(data, "data===", userdetails, "userdetails==", conId, "conId===");


    const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetials;
    console.log("LoginUserDetails", LoginUserDetails);
    if (LoginUserDetails.ext) {
      await this.determineVCIps();
      let ipAddress: string = GetItemFromStorage('IP') || '';
      let IPVersion: string = GetItemFromStorage('IPVersion') || '';
      console.log("ipAddress >>>>>", ipAddress);
      console.log("IPVersion >>>>>", IPVersion);
      if (ipAddress === "") {
        try { ipAddress = await publicIp.v4(); }
        catch (e: any) { ipAddress = "192.168.11.120"; }
      }

      let DNS: string = data.domain_name || '';
      if (isguest) { DNS = (data.video_domain_name || '').trim(); }
      else { DNS = (data.video_meet_domain || '').trim(); }

      const ip = ipAddress;
      const username: number = data.ext;
      const DomainName: string = `${DNS}:5060`;
      const password: string = data.dp_password;

      console.log(password, "password====");

      let stunURL: string = config().VIDEO_CALL_SERVER_STUN_URL || '';
      if (IPVersion === "v6") stunURL = config().VIDEO_CALL_SERVER_V6_STUN_URL_TH || '';
      const videoWssUrl = config().VIDEO_CALL_SERVER_WSS_URL;
      console.log(LocalStorage, "LocalStorage===", "configure", username);

      var configure: any = {
        wsServers: `${videoWssUrl}`,
        viaHost: ip,
        uri: username + "@" + DomainName,
        userAgentString: config().VIDEO_SERVER_USER_AGENT,
        traceSip: true,
        register: true,
        authorizationUser: username,
        password: password,
        turnServers: {
          urls: stunURL,
          username: config().VIDEO_CALL_SERVER_STUN_USERNAME,
          password: config().VIDEO_CALL_SERVER_STUN_PASSWORD
        },
        displayName: username,
        callId: username,
        host: ip,
        custom: {
          'meetingID': meetingDetails.meetingDetails.uuid,
          'connID': conId,
          'shareID': conId + '_screenshare'
        }
      };
      console.log(configure, "configure>>>>>>");
      let videoAgent: any = store.getState().userAgent.UA;
      let UA: any = await Registration(configure);
      console.log("UAA", UA)
      storeUserAgent(UA);
      // let obj:any={};
      // obj.conId=conId;
      // obj.UA=UA;
      // let prevUserAgent:any=store.getState().userAgent.prevUserAgent;
      // let uaArr:any=prevUserAgent.push(obj);
      // storePrevUserAgent(uaArr)
      console.log(videoAgent, "videoAgent====");

      UA.on("accepted", (reason: any) => {

        console.log("<<<<<< accepted >>>>>>>>>", reason.method);
        if (reason.method === 'REGISTER') {
          let videoRenderList: Array<any> = store.getState().storeVideo.participantList || [];
          console.log(videoRenderList, "videoRenderList==");

          if (videoRenderList.length === 0) {
            const meetingDetails: any = storeRedux.getState().meetingReducer;
            console.log("meetingDetailsmeetingDetails12333", meetingDetails)
            this.callNow(meetingDetails.meetingDetails.uuid, conId, userdetails.isHost, medium, DNS);
          }
          else {
            console.log("disconnect and join");
            new videoCallService(this.dispatch).disconnectAndJoin();
          }
        }
      });

    }
    else {
      // toast("something went wrong");
      this.throwError("something went wrong", this.dispatch);
      throwLoading(false);

      console.log("socket loading false error-Something went wrong");
    }
  };

  public resetMultiCheck(){
    inviteCheck=false;
    multiInviteCheck=false;

  }

public async validateMultiInvite(useragent:any){
let prevUserAgent:any=store.getState().userAgent.prevUserAgent;
  if(multiInviteCheck){
    //this if block executes when the first invite is received
    console.log("prevUserAgentprevUserAgent>>>",prevUserAgent);
    console.log("multiinvite check iffff");
if(inviteCheck){
  console.log("inviteCheck check iffff");
  //if already a invite has received 200ok from server then bye needs to be called
  try{
    console.log("invite byee")
    prevUserAgent.bye();
  }
  catch{
    console.log("error in sending bye:",prevUserAgent.state);
  }
}
else{ 
  console.log("inviteCheck check else");
            //if already a invite has just been generated and still hasnt received 200 ok from server  then cancel needs to be called
  console.log("invite cancel")
  try{
    prevUserAgent.cancel();
  }
  catch{
    console.log("error in sending cancel:",prevUserAgent.state);
  }
  }
  storePrevUserAgent(useragent)
  inviteCheck=false;
}
else{
//this else executes when the first invite is received
console.log("multiinvite check else");
multiInviteCheck = true;
storePrevUserAgent(useragent);
}
}


  public  async callNow(sipId: string, connectionId: string, participantType: boolean, medium: string,
    DNS: string) {

    console.log("participantType >>>>>", participantType, "sipIdsipId", sipId)
    let UA: any = store.getState().userAgent.UA;
    let uri = "sip:" + sipId + "@" + DNS;
    console.log("first time uri", uri);
    let extraHeaders: Array<any> = [
      'UR-AV-ConferenceRoom-ID:' + sipId,
      'UR-AV-Conference-UserType:' + (participantType === true ? 6 : 5),
      'UR-AV-ConferenceConn-ID:' + connectionId
    ];

    let useragent =  MakeCall(
      UA, uri, extraHeaders,
      medium, false
    );
 

    this.setUpListeners(useragent, sipId, medium, "OUT", connectionId);


  };

  setUpListeners = async (thissession: any, callerSip: string, medium: string, bound: string, connID: string) => {

    try {

      // await this.validateMultiInvite(thissession)


      thissession.on("accepted", (e: any) => {
        console.log("accept calling");
        inviteCheck=true;
        this.getNewStream(thissession, connID);
      });
      thissession.on("trackAdded", async () => {
        try {
          console.log("trackAdded calling");

          await this.handleTrackAdded(thissession)
        }
        catch (e: any) { console.log("e is", e); }
      });

      thissession.on("failed", function (e: any, f: any) {
        console.log("failed calling e ", e);
        console.log("failed calling f ", f);
      });

    } catch (error) { console.log("Setup lister", error); }

  };


  getNewStream = async (thissession: any, connID: string) => {

    try {

      console.log("getNewStream is");

      let { currdeviceinfo, sockmeetDetails } = store.getState().meetingReducer || [];
      let { callStatus } = store.getState().storeVideo || [];
      if (!currdeviceinfo.mute || currdeviceinfo.video) {
        let { videoStream, audioStream }: any = store.getState().meetingReducer;
        console.log(videoStream, "videoStream===");

        let mediaStream: any = new MediaStream();
        console.log(mediaStream, "mediaStream===");

        var pc = thissession.sessionDescriptionHandler.peerConnection;

        if (!currdeviceinfo.mute && audioStream && audioStream.getAudioTracks().length > 0) {


          mediaStream.addTrack(audioStream.getAudioTracks()[0])
          console.log("audio track inside===", mediaStream);
        }
        else {
          if (audioStream) {
            const tracks = audioStream.getTracks();
            tracks.forEach(function (track: any) {
              track.stop();
            });
          }
        }
        console.log(currdeviceinfo.video, "currdeviceinfo.video ===", videoStream, "videoStream==");

        if (currdeviceinfo.video && videoStream && videoStream.getVideoTracks().length > 0) {
          mediaStream.addTrack(videoStream.getVideoTracks()[0])
          console.log("video track inside===", mediaStream);
        }
        else {
          if (videoStream) {
            const tracks = videoStream.getTracks();
            tracks.forEach(function (track: any) {
              track.stop();
            });
          }
        }
        console.log("getVideoTracks >>>>>>", mediaStream.getVideoTracks()[0]);
        console.log("getAudioTracks >>>>>>", mediaStream.getAudioTracks()[0]);
        pc.getSenders().forEach((sender: any, index: number) => {
          if (index === 0) {
            sender.replaceTrack(mediaStream.getAudioTracks()[0]);
          }
          else if (index === 1) {
            sender.replaceTrack(mediaStream.getVideoTracks()[0]);
          }
        });

        let participantData = [];
        let localVideoStore = {
          participants: connID,
          mid: [0, 1],
          stream: mediaStream,
          userAgent: thissession,
          previousState: currdeviceinfo.mute
        };
        console.log("localVideoStorelocalVideoStore", localVideoStore);
        participantData.push(localVideoStore);
        console.log(participantData, "participantData==");

        storeParticipantVideo(participantData, 2, callStatus);

        if (!currdeviceinfo.mute) {

          // var speechEvents: any;
          //var options = { threshold: -50 };
          if (mediaStream.active === true) {


            //  let cloneMedia = audioStream.clone();
            // speechEvents = hark(cloneMedia, options);
            //detectActiveSpeaker(speechEvents);
            // let speakingEvents:any = new SpeechDetech(cloneMedia, {passThrough: false});

            // this.detectActiveSpeaker(speakingEvents)

          }
        } else {
          let newConstrain = { audio: true, video: false };
          let newmediaStream = await navigator.mediaDevices.getUserMedia(newConstrain);

          // let speakingEvents:any = new SpeechDetech(newmediaStream, {passThrough: false});

          //   this.detectActiveSpeaker(speakingEvents)
        }
        if (currdeviceinfo.video) {
          setTimeout(() => { this.setBandWidth(700); }, 5000);
        }
      }

      if (currdeviceinfo.mute && !currdeviceinfo.video) {
        let participantData = [];
        let localVideoStore = {
          participants: connID,
          mid: [0, 1],
          stream: new MediaStream(),
          userAgent: thissession,
          previousState: currdeviceinfo.mute
        };
        participantData.push(localVideoStore);
        storeParticipantVideo(participantData, 2, callStatus);
        this.stopStream();
      }
      let { iswaiting } = store.getState().storeVideo || [];
      store_Status("Ready");
      console.log(callStatus, "callStatus change to ready===");
      if (iswaiting) {
        this.synchronousCalling();
        storeCallStatus(false);
      }



      /* var browserUa = navigator.userAgent.toLowerCase();
               
      if (browserUa.indexOf('safari') > -1 && browserUa.indexOf('chrome') < 0)   getStats(pc); */

      //  if(sockmeetDetails.isHostjoined){   setTimeout(function() {

      //       pc.getSenders().forEach(function(sender: any) {
      //         var track = sender.track;
      //         if (track) {
      //           if (track.kind === 'audio') track.enabled = false;
      //         }
      //       });

      //   },100); }


      setTimeout(() => {
        // iceConnectionValidation();
      }, 1000)
    } catch (error) {
      console.log("getNewStream >>>>>", error)
    }

  }


  iceConnectionValidation = () => {
    console.log("iceConnectionValidation calling>>>>>>>");
    let userSelfIndex: number = -1;
    try {
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      let { participantList } = store.getState().storeVideo || [];
      userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
      if (userSelfIndex !== -1) {
        let pc: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
        pc.addEventListener("iceconnectionstatechange", (e: any) => {
          if (pc.iceConnectionState === "disconnected" || pc.iceConnectionState === "failed") {
            console.log('<<<<<<< ICE DISCONNECTED CALLING >>>>>>>>>>>>>', pc.iceConnectionState);
            console.log('<<<<<<< ICE FAILED STATE  >>>>>>>>>>>>>', isIcefailed);

            if (!isIcefailed && !isIceTimerStarted) {
              isIcefailed = true;
              clearRestart = setTimeout(() => {
                console.log('<<<<<< SET TIME OUT RECONNECT CALLING >>>>>>>', pc.iceConnectionState);
                this.iceReconnectSocket();
              }, 20000);
            }

          }
          if (pc.iceConnectionState === "connected") {
            if (clearRestart) {
              console.log("clear Timeout calling");
              clearTimeout(clearRestart);
              isIcefailed = false;
              isIceTimerStarted = false;
            }

          }
        });
      }
    } catch (error) {
      console.log(error, "error==")
    }
  }

  iceReconnectSocket = () => {
    console.log("iceReconnectSocket >>>>>>>>>>>>>>")
    let { currdeviceinfo, meetingDetails, iceState, isTransoportClose } = store.getState().meetingReducer;

    let { participantList, socketData } = store.getState().storeVideo || [];

    let userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
    if (userSelfIndex !== -1) {
      let pc: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
      console.log('iceReconnectSocket iceConnectionState', pc.iceConnectionState);
      console.log('iceReconnectSocket isTransoportClose', isTransoportClose);

      // if(pc.iceConnectionState === "connected")isIcefailed=  false ;

      if (!isTransoportClose && (pc.iceConnectionState === "disconnected" || pc.iceConnectionState === "failed")) {

        console.log("<<<<<<<< Scoket reconnecting for ICE failed >>>>>>>>>>>>>");
        const isScreenShare: sharingState = store.getState().screenshare || [];

        this.dispatch(meetActions.iceConnectionState({ iceState: true }))

        if (isScreenShare.sharingStatus && isScreenShare.conId === currdeviceinfo.conId + "_screenshare") {
          this.stopScreenSharing();
          //  store.dispatch({
          //   type: actionTypes.SCREENSHARING_STATUS,
          //   payloads: false,
          //   connId: ""
          // });
          this.dispatch(screenShareReducerAction.screenShareStatus({
            sharingStatus: false, conId: ""
          }))
        }
        else if (isScreenShare.sharingStatus) {
          // store.dispatch({
          //   type: actionTypes.SCREENSHARING_STATUS,
          //   payloads: false,
          //   connId: ""
          // });
          this.dispatch(screenShareReducerAction.screenShareStatus({
            sharingStatus: false, conId: ""
          }))
        }

        //throwReconnect(true);
        storeParticipantVideo([], 2, "Waiting");
        // this.dispatch(storeVideoSliceAction.participantvideolist({participantList:[]}))
        // this.dispatch(storeVideoSliceAction.participantVideoInfo({midValue:2,callStatus:"Waiting"}));
        // store.dispatch({
        //   type: Types.IS_SOCKET_INIT,
        //   payload: {
        //     isSocketInit:false
        //   }
        // });
        this.dispatch(meetActions.socketInitStatus({ isSocketInit: false }))

        console.log("BEFORE RESET TIMER >>>>>>>>", clearRestart)
        if (clearRestart) console.log("<<<<<<< ICE TIMER CLEARING >>>>>>>>>>>"); clearTimeout(clearRestart)

        console.log("AFTER RESET TIMER >>>>>>>>", clearRestart)
        isIcefailed = false;
        isIceTimerStarted = true;
        // disconnectSocketForICE()

        setTimeout(() => {
          isIceTimerStarted = false;
        }, 30000)
        new videoCallService(this.dispatch).createConnection(meetingDetails.uuid,false);
      }
    }
  };


  detectActiveSpeaker = (speechEvents: any) => {
    try {

      speechEvents.bind('speaking', function () {

        // console.log('speaking!');
        let { currdeviceinfo, connstatus, meetingDetails, sockmeetDetails } = store.getState().meetingReducer;
        if (currdeviceinfo.mute && connstatus === "connected") {

          // onMuteStatus(true);
          // toastStatus(`You are on mute`);
          // debugger 
        }
        if (!currdeviceinfo.mute && connstatus === "connected") {
          let meetDetails: any = Object.assign({}, meetingDetails, sockmeetDetails)
          let Input: any = {
            message: 'speaking',
            socketId: currdeviceinfo?.conId
            // meetInfo:meetDetails
          };
          videoCallService.sendActiveSpeakerStatus(Input);
        }
      });

      speechEvents.bind('stoppedSpeaking', function (data: any) {
        //console.log("stoppedSpeaking >>>>>")
        let { currdeviceinfo, connstatus, meetingDetails, sockmeetDetails } = store.getState().meetingReducer || [];
        if (!currdeviceinfo.mute && connstatus === "connected") {
          let meetDetails: any = Object.assign({}, meetingDetails, sockmeetDetails)
          let Input: any = {
            message: 'stopped_speaking',
            socketId: currdeviceinfo?.conId
            // meetInfo:meetDetails
          };
          videoCallService.sendActiveSpeakerStatus(Input);
        }

      });

    }
    catch (e) {
      console.log("error");
    }
  };

  receivedAnswerSdp = (receivedSdp: any) => {
    try {
      let { participantList, callStatus } = store.getState().storeVideo || [];
      console.log("participantListanswersdp", participantList);
      let userSelfIndex: number = -1;
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
      if (userSelfIndex !== -1) {
        let peerConnection: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
        let sdp: any = {};
        sdp.type = "answer";
        sdp.sdp = receivedSdp.sdp;
        console.log(sdp, "sdp===");
        console.log(peerConnection, "peerConnection===");

        peerConnection.setRemoteDescription(sdp);
        // that.dispatch(storeVideoSliceAction.callStatus({ callStatus: "Ready" }));
        console.log(callStatus, "callStatus===");

        store_Status("Ready");

        console.log(callStatus, "callStatus change to waiting ===");
        let { iswaiting } = store.getState().storeVideo || [];
        console.log(iswaiting, "===iswaiting===");
        if (iswaiting) {
          console.log("synchronousCalling calling from receivedAnswerSdp");
          this.synchronousCalling();
          storeCallStatus(false);
        }
      }
    }
    catch (e: any) { console.log("e is", e); }
  };


  synchronousCalling = (dispatch?: any) => {
    console.log("sendingReinvite calling from synchronousCalling");
    storeCallStatus(false);
    // this.dispatch(storeVideoSliceAction.callWaitingStatus({ iswaiting: false }));
    let { socketData } = store.getState().storeVideo || [];
    this.sendingReinvite(socketData);
  };

  sendingReinvite = async (participantDetail: any) => {
    let { participantList, midValue }: any = store.getState().storeVideo || [];
    let { currdeviceinfo, iceState } = store.getState().meetingReducer || [];
    console.log("sendingReinvite is calling", participantList, "smidValuemidValue", midValue);

    try {

      console.log("participantDetail >>>>>>>", participantDetail);
      let currentDeviceInfoIndex = participantDetail.findIndex((elem: any) => elem.conId === currdeviceinfo.conId);

      console.log("currentDeviceInfoIndex >>>>>>", currentDeviceInfoIndex);
      let { callStatus } = store.getState().storeVideo || [];
      if (participantDetail && currentDeviceInfoIndex !== -1) {
        // this.dispatch(storeVideoSliceAction.callStatus({ callStatus: "Waiting" }));
        store_Status("Waiting");
        console.log(callStatus, "callStatus change to waiting ===");
        let { currdeviceinfo, iceState } = store.getState().meetingReducer || [];
        let isSendReinvite: boolean = false;
        let mid = midValue;
        let userSelfIndex: number = -1;

        let currentActivePeople: any = [...participantList].filter((participatStore: any) =>
          participantDetail.some((updatedList: any) =>
            participatStore.participants === updatedList.conId));

        if (currentActivePeople.length !== 0 && (currentActivePeople.length !== participantList.length)) {
          participantList = currentActivePeople;
          isSendReinvite = true;
        }
        console.log(participantDetail, "participantDetail====");
        userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
        console.log(userSelfIndex, "userSelfIndex===");
        if (userSelfIndex !== -1) {
          let pc: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
          console.log("Self peer connection is >>>>>", pc);
          if (pc) {
            for (let i = 0; i < participantDetail.length; i++) {
              let index: number = -1;
              index = participantList.findIndex((elem: any) =>
                elem.participants === participantDetail[i].conId);
              if (index === -1 && pc.signalingState !== "closed") {
                let mid_Value: any = [];
                if (participantDetail[i].conId.includes("_screenshare")) {
                  mid_Value.push(mid++);
                  pc.addTransceiver("video", { direction: 'recvonly' });
                }
                else {
                  mid_Value.push(mid++);
                  mid_Value.push(mid++);
                  pc.addTransceiver("audio", { direction: 'recvonly' });
                  pc.addTransceiver("video", { direction: 'recvonly' });
                }
                let sipVideo: any = {
                  participants: participantDetail[i].conId,
                  mid: mid_Value,
                  stream: '',
                  userAgent: participantList[userSelfIndex].userAgent
                };

                participantList.push(sipVideo);
                console.log("participantListparticipantList+", participantList);
                // participantList=[...participantList,sipVideo];
                isSendReinvite = true;
              }
            }
            console.log("before calling", isSendReinvite);
            if (isSendReinvite && participantList.length !== 0) {
              storeParticipantVideo(participantList, mid, "Waiting");
              // this.dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
              // this.dispatch(storeVideoSliceAction.participantVideoInfo({midValue:mid,callStatus:"Waiting"}));
              let sessionDescription = await pc.createOffer();
              let removedCodec: any = this.removeUnwantedCodec(sessionDescription.sdp);
              sessionDescription.sdp = removedCodec;
              pc.setLocalDescription(sessionDescription);
              let query: any = { sdp: sessionDescription.sdp, participantList: participantDetail, socketId: currdeviceinfo.conId };
              videoCallService.sendUpdatedSdp(query);



            }
            else {
              console.log("call state changing to Ready");
              // this.dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
              // this.dispatch(storeVideoSliceAction.participantVideoInfo({midValue:midValue,callStatus:"Ready"}));
              storeParticipantVideo(participantList, midValue, "Ready");
            }
          }

        }
      }
    }
    catch (e: any) {
      console.log("error is e", e);
      // this.dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
      // this.dispatch(storeVideoSliceAction.participantVideoInfo({midValue:midValue,callStatus:"Ready"}));
      storeParticipantVideo(participantList, midValue, "Ready");
    }
  };

  removeUnwantedCodec = (message: any) => {

    // let videoBandwidth = 64;
    // message = message.replace("a=mid:1", "a=mid:1\r\nb=AS:" + videoBandwidth);
    message = message.replace(/sendrecv/g, 'recvonly');
    message = message.replace("a=recvonly", "a=sendonly");
    message = message.replace("a=recvonly", "a=sendonly");
    let mainSDP = message;
    message = message.split('\r\n');
    let sdp = '';
    let listOfcodec = [];
    let defaultAudioCodec = ['opus'];
    let defaultVideoCodec = ['VP8', 'VP9'];

    for (var i = 0; i < message.length; i++) {
      if (message[i].includes('m=audio')) {
        let payload_data = message[i].split("SAVPF ")
        let payload = payload_data[1].split(" ");
        let codec = "";

        if (payload_data[1].length > 0) {
          for (let j = 0; j < payload.length; j++) {
            for (let k = 0; k < defaultAudioCodec.length; k++) {
              if (mainSDP.includes(payload[j] + " " + defaultAudioCodec[k])) {
                listOfcodec.push(payload[j]);
                codec += (codec === "") ? payload[j] : " " + payload[j];
              }
            }
          }
        }
        let finalData = payload_data[0] + "SAVPF " + codec;
        sdp += finalData + '\r\n';
      }
      else if (message[i].includes('m=video')) {
        let payload_data = message[i].split("SAVPF ");
        let payload = payload_data[1].split(" ");
        let codec = "";
        for (let j = 0; j < payload.length; j++) {
          for (let k = 0; k < defaultVideoCodec.length; k++) {
            if (mainSDP.includes(payload[j] + " " + defaultVideoCodec[k])) {
              listOfcodec.push(payload[j]);
              codec = (codec === "") ? payload[j] : codec + " " + payload[j];
              if (mainSDP.includes(payload[j + 1] + " rtx")) {
                listOfcodec.push(payload[j + 1]);
                codec += " " + payload[j + 1];
              }
            }
          }
        }
        let finalData = payload_data[0] + "SAVPF " + codec;
        sdp += finalData + '\r\n';
      }
      else if (message[i].includes('a=rtpmap')) {
        let codec = (message[i].split('a=rtpmap:')[1]).split(" ")[0];
        if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
      }
      else if (message[i].includes('a=rtcp-fb')) {
        let codec = (message[i].split('a=rtcp-fb:')[1]).split(" ")[0];
        if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
      }
      else if (message[i].includes('a=fmtp')) {
        let codec = (message[i].split('a=fmtp:')[1]).split(" ")[0];
        if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
      }
      else {
        sdp += message[i];
        if (i !== message.length - 1) sdp += '\r\n';
      }
    }

    return sdp;

  };

  stopStream = () => {
    let { videoStream, audioStream }: any = store.getState().meetingReducer || [];
    if (videoStream) {
      const tracks = videoStream.getTracks();
      tracks.forEach(function (track: any) {
        track.stop();
      });
    }
    if (audioStream) {
      const tracks = audioStream.getTracks();
      tracks.forEach(function (track: any) {
        track.stop();
      });
    }
  };

  determineVCIps() {
    let PublicIp = ''
    let ipVersion = 'v4';
    console.log("determineIps >>>>>>>");
    return fetch('https://getip.worktual.co.uk/')
      .then(response => response.text()).then((data: any) => {
        try {

          PublicIp = (JSON.parse(data)).clientIPv6
          if (PublicIp.includes(":")) {
            PublicIp = "[" + PublicIp + "]";
            ipVersion = 'v6';
          }
          let existingIp: any = GetItemFromStorage('IP');
          let isIPChanged: boolean = existingIp !== PublicIp
          SetItemInStorage('IP', PublicIp);
          SetItemInStorage('IPVersion', ipVersion);
          return { IP: PublicIp, IPVersion: ipVersion, isIPChanged: isIPChanged }
        } catch (error) {
          console.log("error determineIps >>>>", error);
        }

      }).catch(error => console.error(error));

  };

  handleTrackAdded = async (thissession: any) => {
    try {
      let { iceState } = store.getState().meetingReducer || [];
      if (iceState) {
        setTimeout(() => {
          store.dispatch({
            type: meetActionTypes.ICE_CONNECTION_STATE,
            payload: {
              iceState: false
            }
          });
        }, 10000)
      }
      setTimeout(()=>{
        store.dispatch({
          type: meetActionTypes.UPDATE_VIRTUAL_STATUS,
          payload: {
            viewMode: "Active Speaker",
            peerConCheck:true
          }
        });
      },1000)
      let { participantList, midValue, callStatus } = store.getState().storeVideo || [];
      var pc = thissession.sessionDescriptionHandler.peerConnection;
      let isAdded: boolean = false;
      for (let z = 1; z < participantList.length; z++) {
        console.log("track added 1");

        if ((participantList[z].stream === "") || (participantList[z]?.stream?.active === false)) {
          console.log("track added 2");
          let remoteStream = new MediaStream();
          if (participantList[z].participants.includes("_screenshare")) {
            const videoTransceiver = pc.getTransceivers().filter((transceiver: any) =>
              transceiver.mid === (participantList[z].mid[0]).toString());
            if (videoTransceiver.length !== 0) {
              remoteStream.addTrack(videoTransceiver[0].receiver.track);
              participantList[z].stream = remoteStream;
              isAdded = true;
            }
          }
          else {
            console.log("track added 3");
            for (let b = 0; b < 2; b++) {

              const mediaFile = pc.getTransceivers().filter((transceiver: any) =>
                transceiver.mid === (participantList[z].mid[b]).toString());
              console.log("track added 4", mediaFile);
              if (mediaFile.length !== 0) {
                if (mediaFile[0].receiver.track.kind === "audio") {
                  audioStream.addTrack(mediaFile[0].receiver.track);
                }
                else {
                  console.log("track added 5", remoteStream);
                  remoteStream.addTrack(mediaFile[0].receiver.track);
                  console.log("track added 6", mediaFile[0]);
                  participantList[z].stream = remoteStream;
                  isAdded = true;
                }
              }
              else { participantList[z].stream = ""; }
            }
          }
        }
      }

      if (isAdded) {
        console.log("asdfgh", callStatus);

        storeParticipantVideo(participantList, midValue, callStatus);
        // let { viewMode } = store.getState().VirtualBG || [];
        // if (viewMode === "Grid View") {
        //     console.log("maincontainer calling 6");
        //     maincontainer();
        // }
      }
      //}

      if (mixer) {
        mixer.srcObject = audioStream;
        mixer.autoPlay = true;
      }
    } catch (error) {
      console.log("handleTrackAdded error>>>>", error)
    }

  }

  //  handleTrackAdded = async (thissession: any) => {
  //   try {
  //     let { iceState, audioStream, videoStream }:any = store.getState().meetingReducer || [];
  //     if (iceState) {
  //       setTimeout(() => {
  //         // store.dispatch({
  //         // type: Types.ICE_CONNECTION_STATE,
  //         // payload:{
  //         // iceState : false
  //         // }
  //         // });
  //         this.dispatch(meetActions.iceConnectionState({ iceState: false }));

  //       }, 10000)
  //     }
  //      let { participantList, midValue, callStatus } = store.getState().storeVideo || [];
  //    // let participantList :any = store.getState().storeVideo;
  //     var pc = thissession.sessionDescriptionHandler.peerConnection;
  //     let isAdded: boolean = false;
  //     console.log("participantList  >>>>>>>>>>>>>>>>>>>>", participantList)
  //     let duplicateParticipant:any = [...participantList]


  //     console.log("duplicateParticipant  >>>>>>>>>>>>>>>>>>>>", duplicateParticipant)
  //     for (let z = 1; z < participantList.length; z++) {
  //       if ((participantList[z].stream === "") || (participantList[z]?.stream?.active === false)) {
  //         let remoteStream = new MediaStream();
  //         if (participantList[z].participants.includes("_screenshare")) {
  //           const videoTransceiver = pc.getTransceivers().filter((transceiver: any) =>
  //             transceiver.mid === (participantList[z].mid[0]).toString());
  //           if (videoTransceiver.length !== 0) {
  //             remoteStream.addTrack(videoTransceiver[0].receiver.track);
  //             participantList[z].stream = remoteStream;
  //             isAdded = true;
  //           }
  //         }
  //         else {


  //           for (let b = 0; b < 2; b++) {
  //             const mediaFile = pc.getTransceivers().filter((transceiver: any) =>
  //               transceiver.mid === (participantList[z].mid[b]).toString());
  //             if (mediaFile.length !== 0) {
  //               if (mediaFile[0].receiver.track.kind === "audio") {
  //                 audioStream.addTrack(mediaFile[0].receiver.track);
  //               }
  //               else {
  //                 console.log(participantList[z],"participantList-==");
  //                 // let arr:any=[];

  //                 // arr.push(remoteStream.addTrack(mediaFile[0].receiver.track));
  //                 participantList[z].stream = remoteStream;
  //                 isAdded = true;
  //               }
  //             }
  //             else { participantList[z].stream = ""; }
  //           }
  //         }
  //       }
  //     }

  //     // if (isAdded) {
  //     //   dispatch(storeVideoSliceAction.participantVideoInfo({participantList:participantList,midValue:midValue,callStatus:callStatus}));

  //     //     // storeParticipantVideo(participantList, midValue, callStatus);
  //     //     let { viewMode } = store.getState().VirtualBG || [];
  //     //     if (viewMode === "Grid View") {
  //     //         console.log("maincontainer calling 6");
  //     //         maincontainer();
  //     //     }
  //     // }
  //     //}

  //     if (mixer) {
  //       mixer.srcObject = audioStream;
  //       mixer.autoPlay = true;
  //     }
  //   } catch (error) {
  //     console.log("handleTrackAdded error>>>>", error)
  //   }

  // }




  setBandWidth = (bandwidth: any, conId?: string, dispatch?: any) => {
    try {
      console.log("BandWidth changed to :- ", bandwidth + "kbps");
      let { participantList } = store.getState().storeVideo || [];
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      let index: number = -1;

      let id: string = (conId !== undefined) ? conId : currdeviceinfo.conId;
      index = participantList.findIndex((elem: any) => elem.participants === id);
      if (index !== -1) {

        var pc: any = participantList[index].userAgent.sessionDescriptionHandler.peerConnection;
        const sender = pc.getSenders()[(conId !== undefined) ? 0 : 1];
        if (sender) {
          const parameters = sender.getParameters();
          if (!parameters.encodings) { parameters.encodings = [{}]; }
          parameters.encodings[0].maxBitrate = bandwidth * 1000;
          sender.setParameters(parameters)
            .then(() => {
              // dispatch(storeVideoSliceAction.currentBandwidth({ currentBandwidth: bandwidth }));

              store.dispatch({
                type: actionTypes.VIDEO_BANDWIDTH,
                payload: bandwidth
              });
            })
            .catch((e: any) => console.error("error is", e));
        }
      }
    }
    catch (e: any) { console.log("setBandWidth not seted properly", e); }
  };
  inviteBinding = (UA: any) => {
    UA.on("registrationFailed", function (reason: any) {
      console.log("Registration Failed***********", reason);
    });
  }

  throwError = _.debounce((err: string, dispatch?: any) => {
console.log("errrrrrr",err);
toast(err);
    setTimeout(() => {
      //  dispatch(meetActions.updateSocketError({ isError: { message: err }, isSuccess: { message: '' } }));
      store.dispatch({
        type:meetActionTypes.SOCKET_ERROR,
        payload:{
          isError:{
            message:err
          },
          isSuccess:{
            message:""
          }
        }
      })
    }, 3000);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('createConnection');
  }, 1000);

  sendRe_invite = async (input: any) => {

    let { participantList, midValue, callStatus } = store.getState().storeVideo || [];
    var constraints = {
      audio: false,
      video: { width: 1280, height: 720, frameRate: { ideal: 25, max: 30 } }
    };

    let mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    var pc: any = participantList[0].userAgent.sessionDescriptionHandler.peerConnection;
    pc.getSenders().forEach((sender: any, index: number) => {
      if (index === 1) {
        sender.replaceTrack(mediaStream.getVideoTracks()[0]);
      }
    });
    let replaceStream: any = participantList[0].stream;
    var videoTrack = replaceStream.getVideoTracks();
    if (videoTrack.length > 0) {
      replaceStream.removeTrack(videoTrack[0]);
    }
    replaceStream.addTrack(mediaStream.getVideoTracks()[0]);
    participantList[0].stream = replaceStream;
    storeParticipantVideo(participantList, midValue, callStatus);
    videoCallService.videoStatus(input);
    // toastStatus(`Video ON`);
  };



  stopScreenSharing = () => {
    try {
      let { participantList, midValue } = store.getState().storeVideo || [];
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      // const virtualBGState:any = store.getState().VirtualBG;
      let conId = currdeviceinfo.conId + '_screenshare';
      let jsonData: any = {};
      jsonData.shape = 'SCREENSHARING_STATUS';
      jsonData.status = false;
      jsonData.conId = conId;
      let input = {
        sipId: conId,
        message: jsonData,
        type: 'stop'
      };

      videoCallService.sendScreenShare(input)


      // store.dispatch({
      //   type: Types.UPDATE_VIRTUAL_STATUS,
      //   payload: {
      //     viewMode:virtualBGState.previousView
      //   }
      // });

      let index: number = -1;
      index = participantList.findIndex((elem: any) => elem.participants === conId);
      if (index !== -1) {
        let stream = participantList[index].stream;
        stream.getTracks().forEach((track: any) => (track.kind === "video" ? track.stop() : ''));
        participantList.splice(index, 1);
        storeParticipantVideo(participantList, midValue, "Ready");
        // this.dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
        // this.dispatch(storeVideoSliceAction.participantVideoInfo({midValue: midValue, callStatus: "Ready" }))
      }


      // if (virtualBGState.dupImage) {
      //   updateVirtualBGRedux(virtualBGState.dupImage, virtualBGState.dupImgIndex);
      // }

    }
    catch (e) { console.log("e is", e); }
  };



  screenShareListener = (thissession: any, connID: string) => {
    try {

      let self = this;


      console.log("new self.meetServiceCall.synchronousCalling() >>>>>>");
      thissession.on("accepted", function (e: any) {
        store_Status("Ready");
        let { iswaiting } = store.getState().storeVideo || [];
        if (iswaiting) {
          console.log("synchronousCalling calling from screenShareListener");

          self.synchronousCalling();
          storeCallStatus(false);
        }
        setTimeout(function () { self.setBandWidth(1000, connID); }, 5000);
      });

      thissession.on("trackAdded", function () {
        try {
          var pc = thissession.sessionDescriptionHandler.peerConnection;
          let { participantList, midValue, iswaiting } = store.getState().storeVideo || [];
          let index: number = -1;
          index = participantList.findIndex((elem: any) => elem.participants === connID);

          console.log("index >>>>>>>", index);
          console.log("pc.getTransceivers().length >>>>>>>", pc.getTransceivers().length);
          if (index !== -1 && pc.getTransceivers().length !== 0) {
            let localStream = new MediaStream();
            let videoTrack = pc.getTransceivers()[0].sender.track;
            console.log("videoTrack >>>>>>>>>", videoTrack);
            localStream.addTrack(videoTrack);
            participantList[index].stream = localStream;
            storeParticipantVideo(participantList, midValue, "Ready");
            localStream.getVideoTracks()[0].onended = function () {

              console.log("SCRREN SHARE STOP CALLING>>>>>");
              self.stopScreenSharing();
            };
          }
          if (iswaiting) { self.synchronousCalling(); }
        }
        catch (e: any) { console.log("e is", e); }
      });
    }
    catch (e: any) { console.log("e is", e); }
  };

  startSharing = () => {
    let { meetingDetails, currdeviceinfo } = store.getState().meetingReducer;
    const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
    console.log(userDetials, "userDetials===");
    console.log("meetingDetails >>>>>>>", meetingDetails);
    console.log("currdeviceinfo >>>>>>>", currdeviceinfo);

    let loggedUserDetails: any = userDetials || {};
    let { callStatus } = store.getState().storeVideo || [];

    let DNS = (currdeviceinfo.isGuest) ? (loggedUserDetails.video_domain_name || '').trim() :
      (loggedUserDetails.video_meet_domain || '').trim();

    let UA: any = store.getState().userAgent.UA;
    let uri: string = "sip:" + meetingDetails.uuid + "@" + DNS;
    let connectionId: string = currdeviceinfo.conId + '_screenshare';

    let extraHeaders: Array<any> = [
      'UR-AV-ConferenceRoom-ID:' + meetingDetails.uuid,
      'UR-AV-Conference-UserType:4',
      'UR-AV-ConferenceConn-ID:' + connectionId
    ];


    let useragent = startScreenShare(UA, uri, extraHeaders);

    let { participantList, midValue } = store.getState().storeVideo || [];
    let sipVideo = {
      participants: connectionId,
      mid: 0,
      stream: '',
      userAgent: useragent
    };
    participantList.push(sipVideo);
    storeParticipantVideo(participantList, midValue, callStatus);

    videoCallService.sendScreenShareInvite()

    this.screenShareListener(useragent, connectionId);

  };
}

export const sipCallEnd = () => {
  try {
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let videoRenderList: any = store.getState().storeVideo.participantList || [];
    let currentUserData: any = _.find(videoRenderList, { participants: currdeviceinfo.conId });
    if (currentUserData !== undefined) {
      EndCall(currentUserData.userAgent);
      let vedioStream = currentUserData.stream;
      const tracks = vedioStream.getTracks();
      tracks.forEach(function (track: any) {
        track.stop();
      });
    }
  }
  catch (e) { console.log("error is", e); }
};

export const video_disable = (input: any) => {
  try {
    videoCallService.videoStatus(input);
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let videoRenderList: any = store.getState().storeVideo.participantList || [];
    let currentUserData: any = _.find(videoRenderList, { participants: currdeviceinfo.conId });
    if (currentUserData !== undefined) {

      let vedioStream = currentUserData.stream;
      const tracks = vedioStream.getTracks();
      tracks.forEach(function (track: any) {
        if (track.kind === "video") {
          track.stop();
        }
      });
      // toastStatus(`Video OFF`);
    }
  }
  catch (e) { console.log("error is", e); }
}

export const unMuteWithNewStream = async (condId: string) => {
  try {
    let { participantList, midValue, callStatus } = store.getState().storeVideo || [];

    let index: number = -1;
    index = participantList.findIndex((elem: any) => elem.participants === condId);
    if (index !== -1) {
      let newConstrain = { audio: true, video: false };
      let mediaStream = await navigator.mediaDevices.getUserMedia(newConstrain);
      var pc: any = participantList[index].userAgent.sessionDescriptionHandler.peerConnection;

      var transceiverToStop: any =
        pc.getTransceivers().filter(function (transceiver: any) { return transceiver.mid === '0'; });

      transceiverToStop[0].sender.replaceTrack(mediaStream.getAudioTracks()[0]);
      let currentUserDetail: any = participantList[index];
      let oldStream: any = currentUserDetail.stream;
      if (oldStream.getAudioTracks().length > 0) {
        oldStream.removeTrack(oldStream.getAudioTracks()[0]);
      }
      oldStream.addTrack(mediaStream.getAudioTracks()[0]);
      currentUserDetail.stream = oldStream;
      participantList[index] = currentUserDetail;
      participantList[index].previousState = false;
      storeParticipantVideo(participantList, midValue, callStatus);
      //var speechEvents:any;
      //var options = { threshold:-50 };
      let cloneMedia = audioStream.clone();

      console.log("<<<<<< audioStream >>>>>>", audioStream);
      //speechEvents = hark(cloneMedia, options);
      // let speakingEvents:any = new SpeechDetech(cloneMedia, {passThrough: false});

      //detectActiveSpeaker(speakingEvents);
    }
  }
  catch (e: any) { console.log("error is", e); }
};
export const videoDisable = () => {
  let { currdeviceinfo } = store.getState().meetingReducer || [];
  let videoRenderList: any = store.getState().storeVideo.participantList || [];
  let index: number = -1;
  index = videoRenderList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
  if (index !== -1) {
    let oldStream = videoRenderList[index].stream;
    oldStream.getTracks().forEach((track: any) => (track.kind === "video" ? track.stop() : ''));
  }
};

export const toggleVideo = (toggle:boolean) =>{
  console.log("toggleVideo",toggle);
    store.dispatch({
      type: meetActionTypes.TOGGLE_VIDEO,
      payload: {
        videoToggle:toggle
      }
    });
  };

  export const toggleAudio = (toggle:boolean) =>{
    store.dispatch({
      type: meetActionTypes.TOGGLE_AUDIO,
      payload: {
        muteToggle:toggle
      }
    });
  };